import { create } from 'zustand'

export interface ProfileSlice {
  tempIconFile: File | null
  tempCoverIconFile: File | null
  setTempIconFile: (iconFile: File | null) => void
  setTempCoverIconFile: (iconFile: File | null) => void
  isIconDeleted : boolean
  setIsIconDeleted : (value : boolean) => void
  isCoverIconDeleted : boolean
  setIsCoverIconDeleted : (value : boolean)=>void

}

export const useProfile = create<ProfileSlice>((set) => ({
  tempIconFile: null,
  tempCoverIconFile : null,
  isIconDeleted : false,
  isCoverIconDeleted : false,
  setIsIconDeleted : (value : boolean) => {
    set({isIconDeleted : value})
  },
  setIsCoverIconDeleted : (value : boolean) => {
    set({isCoverIconDeleted : value})
  },
  setTempIconFile: (iconFile: File | null) => {
    set({ tempIconFile: iconFile })
  },
  setTempCoverIconFile: (iconFile: File | null) => {
    set({ tempCoverIconFile: iconFile })
  },
}))
